import React from 'react'

export interface KVItem {
  label: string
  value: React.ReactNode
  /** Optional highlight color applied to the value, e.g. `text-gain`. */
  valueClassName?: string
}

export interface BroadsheetKVListProps {
  items: KVItem[]
}

/**
 * BroadsheetKVList
 *
 * Mono-label / serif-value key-value list. Used throughout the broadsheet for
 * "Trends & Forecast", "ROI Metrics", and "Score Metrics" sections. Each row
 * has a 1 px bottom rule (omitted on the last item) matching the `.kv` pattern
 * from the V2 mockups.
 *
 * Phase 0 primitive — purely presentational.
 */
export function BroadsheetKVList({ items }: BroadsheetKVListProps): React.ReactElement {
  return (
    <dl className="w-full">
      {items.map(({ label, value, valueClassName = '' }, i) => (
        <div
          key={i}
          className="flex items-baseline justify-between gap-2 py-1.5 border-b border-rule last:border-0"
        >
          <dt className="text-[11px] text-graphite">{label}</dt>
          <dd
            className={[
              'font-mono text-[11px] font-medium tabular-nums text-ink',
              valueClassName,
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
